import { StationCollection, PodcastCollection, TagCollection, ShowCollection } from './index';
/**
 * @class
 * A representation of an Search result
 *
 * @param {Array} searchResult - search result
 */

export default class SearchResult {
  stations = [];

  podcasts = [];

  genres = [];

  moods = [];

  liveShows = [];

  onDemands = [];

  constructor(searchResults) {
    if (!searchResults) {
      return null;
    }

    if (searchResults.collection) {
      // Depracated Search, will be removed after next universal api release
      searchResults.collection.forEach((collection) => {
        switch (collection.type) {
          case 'stationCollection':
            this.stations.push(...new StationCollection(collection).items);
            break;
          case 'podcastCollection':
            this.podcasts.push(...new PodcastCollection(collection).items);
            break;
          case 'tagCollection':
            if (collection.slug.includes('genres')) {
              this.genres.push(...new TagCollection(collection).items);
            } else if (collection.slug.includes('moods')) {
              this.moods.push(...new TagCollection(collection).items);
            }
            break;
          default:
            break;
        }
      });
    } else {
      this.stations = new StationCollection(searchResults.stations).items;
      this.podcasts = new PodcastCollection(searchResults.podcasts).items;
      this.genres = new TagCollection(searchResults.genres).items;
      this.moods = new TagCollection(searchResults.moods).items;
      this.liveShows = new ShowCollection(searchResults.liveShows).items;
      this.onDemands =
        new ShowCollection(searchResults.onDemands).items.reduce(
          (acc, cur) => acc.concat(cur.episodes.map((episode) => episode)),
          []
        ) || [];
    }

    // Make this class read-only
    Object.freeze(this);
  }
}
